import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../components/CustomComponent.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
const color = [
  "255, 99, 132", // Red
  "54, 162, 235", // Blue
  "255, 206, 86", // Yellow
  "75, 192, 192", // Teal
  "153, 102, 255", // Purple
  "255, 159, 64", // Orange
  "199, 199, 199", // Gray
  "255, 99, 71", // Tomato
  "60, 179, 113", // Medium Sea Green
  "123, 104, 238", // Medium Slate Blue
  "255, 105, 180", // Hot Pink
  "0, 191, 255", // Deep Sky Blue
  "46, 139, 87", // Sea Green
  "255, 215, 0", // Gold
  "70, 130, 180", // Steel Blue
  "218, 112, 214", // Orchid
  "244, 164, 96", // Sandy Brown
  "0, 128, 128", // Teal Dark
  "205, 92, 92", // Indian Red
  "112, 128, 144", // Slate Gray
];

const MIN_VISIBLE_LABEL_PERCENT = 5;
const MAX_VISIBLE_LABELS = 4;
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_date: format_date(new Date(), "yyyy-mm", "en"),

      data_date: [],

      data_warehouse: [],
      data_return_goods: [],
      data_order_lists: [],
      data_repairs: [],
    };
  }

  async componentDidMount() {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      ArcElement,
      Title,
      Tooltip,
      Legend,
      ChartDataLabels,
    );
    loading(false);
    await this.Get(0);
  }
  getMonthRange = (yearMonth) => {
    if (!yearMonth) return { start_date: "", end_date: "" };

    const [year, month] = yearMonth.split("-").map(Number);

    const start_date = `${year}-${String(month).padStart(2, "0")}-01`;
    const lastDay = new Date(year, month, 0).getDate();
    const end_date = `${year}-${String(month).padStart(2, "0")}-${lastDay}`;

    return { start_date, end_date, year, month, lastDay };
  };

  onChangeDate = () => {
    const { filter_date } = this.state;
    const { year, month, lastDay } = this.getMonthRange(filter_date);

    let data_date = [];

    for (let day = 1; day <= lastDay; day++) {
      data_date.push(
        `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}`,
      );
    }

    this.setState({ data_date });
  };

  Get = async () => {
    loading(true);
    const { filter_date } = this.state;
    const { start_date, end_date } = this.getMonthRange(filter_date);
    let data_warehouse = [],
      data_return_goods = [],
      data_order_lists = [],
      data_repairs = [];
    let [
      result_warehouse,
      result_return_goods,
      result_order_lists,
      repair_repairs,
    ] = await Promise.all([
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/stock-activities/list", {
        page: 0,
        page_size: 10000,
        data_search: "",
        start_date: start_date,
        end_date: end_date,
        warehouse_id: "",
        supplier_id: "",
        status_code: "",
        type: "รับสินค้า",
      }),
      GET("admin/sales/list", {
        page: 0,
        page_size: 10000,
        data_search: "",
        start_date: start_date,
        end_date: end_date,
        warehouse_id: "",
        payment_type: "",
        status_code: "",
        withdrawal_type: "ขายหน้าร้าน,รอสั่งสินค้า",
      }),
      GET("admin/repairs/list", {
        page: 0,
        page_size: 10000,
        data_search: "",
        start_date: start_date,
        end_date: end_date,
        status_code: "",
      }),
    ]);

    // คลังสินค้า
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        id: e.id,
        name: e.name,
      }));
    }

    // รับสินค้า
    if (result_return_goods?.status) {
      for (let item of data_warehouse) {
        data_return_goods.push(
          total(
            result_return_goods.data.filter((e) => e.warehouse_id == item.id && e.status !== "ยกเลิก"),
            "amount_net",
          ),
        );
      }
    }

    // ขายสินค้า
    if (result_order_lists?.status) {
      for (let item of data_warehouse) {
        data_order_lists.push(
          total(
            result_order_lists.data.filter((e) => e.warehouse_id == item.id && e.status !== "ยกเลิก"),
            "amount_net",
          ),
        );
      }
    }

    // แจ้งซ่อม
    if (repair_repairs?.status) {
      for (let item of data_warehouse) {
        data_repairs.push(
          total(
            repair_repairs.data.filter((e) => e.warehouse_id == item.id && e.status !== "ยกเลิก"),
            "amount_net",
          ),
        );
      }
    }

    this.setState({
      data_warehouse,
      data_return_goods,
      data_order_lists,
      data_repairs,
    });
    loading(false);
  };

  getPieOptions = (values = []) => ({
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 44,
        right: 56,
        bottom: 28,
        left: 56,
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = Number(context.raw || 0);
            const totalValue = values.reduce((sum, item) => sum + Number(item || 0), 0);
            const percent = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : "0.0";
            return `${context.label}: ${toFixed(value)} (${percent}%)`;
          },
        },
      },
      datalabels: {
        color: "#000",
        font: {
          weight: "bold",
          size: 11,
        },
        anchor: (ctx) => {
          const chartData = ctx.chart.data.datasets?.[0]?.data || [];
          const maxValue = Math.max(...chartData.map((item) => Number(item || 0)));
          const value = Number(ctx.dataset.data[ctx.dataIndex] || 0);
          return value === maxValue ? "center" : "end";
        },
        align: (ctx) => {
          const chartData = ctx.chart.data.datasets?.[0]?.data || [];
          const maxValue = Math.max(...chartData.map((item) => Number(item || 0)));
          const value = Number(ctx.dataset.data[ctx.dataIndex] || 0);
          return value === maxValue ? "center" : "end";
        },
        offset: (ctx) => {
          const chartData = ctx.chart.data.datasets?.[0]?.data || [];
          const maxValue = Math.max(...chartData.map((item) => Number(item || 0)));
          const value = Number(ctx.dataset.data[ctx.dataIndex] || 0);
          return value === maxValue ? 0 : 8;
        },
        clamp: true,
        clip: false,
        textAlign: "center",
        display: (ctx) => {
          const chartData = ctx.chart.data.datasets?.[0]?.data || [];
          const totalValue = chartData.reduce((sum, item) => sum + Number(item || 0), 0);
          const value = Number(ctx.dataset.data[ctx.dataIndex] || 0);
          if (value <= 0 || totalValue <= 0) return false;

          const percent = (value / totalValue) * 100;
          if (percent < MIN_VISIBLE_LABEL_PERCENT) return false;

          // Keep only top N slices visible to avoid overlapping labels.
          const sortedIndexes = [...chartData]
            .map((item, index) => ({ index, value: Number(item || 0) }))
            .sort((a, b) => b.value - a.value)
            .slice(0, MAX_VISIBLE_LABELS)
            .map((item) => item.index);

          return sortedIndexes.includes(ctx.dataIndex);
        },
        formatter: (value, ctx) => {
          const chartData = ctx.chart.data.datasets?.[0]?.data || [];
          const totalValue = chartData.reduce((sum, item) => sum + Number(item || 0), 0);
          const percent = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : "0.0";
          return `${toFixed(value)}\n(${percent}%)`;
        },
      },
      legend: {
        position: "bottom",
      },
    },
  });

  getPieData = (data_warehouse = [], data = []) => ({
    labels: data_warehouse.map((e) => e.name),
    datasets: [
      {
        id: 1,
        label: "Amount Net",
        data,
        backgroundColor: data_warehouse.map((e, i) => `rgba(${color[i]}, 0.2)`),
        borderColor: data_warehouse.map((e, i) => `rgba(${color[i]}, 1)`),
        borderWidth: 2,
      },
    ],
  });

  render() {
    const {
      filter_date,
      data_warehouse,
      data_return_goods,
      data_order_lists,
      data_repairs,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="d-flex justify-content-between mb-3">
            <h3 className="fw-bold mb-3">Dashboard</h3>
            <input
              type="month"
              className="form-control wpx-200"
              onChange={(e) => {
                this.setState({ filter_date: e.target.value }, () => {
                  this.Get();
                });
              }}
              value={filter_date}
            />
          </div>
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <div className="bg-light rounded-3 p-3 pb-4">
                <h5 className="fw-bold mb-3">รับสินค้า</h5>
                <div style={{ minHeight: 400 }}>
                  <Pie
                    datasetIdKey="id"
                    options={this.getPieOptions(data_return_goods)}
                    data={this.getPieData(data_warehouse, data_return_goods)}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="bg-light rounded-3 p-3 pb-4">
                <h5 className="fw-bold mb-3">ขายสินค้า</h5>
                <div style={{ minHeight: 400 }}>
                  <Pie
                    datasetIdKey="id"
                    options={this.getPieOptions(data_order_lists)}
                    data={this.getPieData(data_warehouse, data_order_lists)}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="bg-light rounded-3 p-3 pb-4">
                <h5 className="fw-bold mb-3">แจ้งซ่อม</h5>
                <div style={{ minHeight: 400 }}>
                  <Pie
                    datasetIdKey="id"
                    options={this.getPieOptions(data_repairs)}
                    data={this.getPieData(data_warehouse, data_repairs)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
